import { getContext } from 'svelte';
export const FormContextKey = Symbol('InertiaFormContext');
export function useFormContext() {
    return getContext(FormContextKey);
}
